export const courseDetails = [
  {
    id: 1,
    name: '수능 국어 완성반',
    level: '고3',
    description: '수능 국어 1등급을 위한\n체계적인 커리큘럼',
    fullDescription: '수능 국어 1등급을 목표로 하는 고3 학생들을 위한 완성반입니다. 15년 경력의 전문 강사진이 최신 출제 경향을 반영한 체계적인 커리큘럼으로 지도합니다. 문학, 독서, 언어와 매체 영역을 균형 있게 학습하며, 실전 감각을 극대화합니다.',
    schedule: '매주 수요일 6~10시',
    capacity: '20명',
    duration: '6개월 과정',
    instructor: '정기훈 원장',
    features: ['기출 문제 완벽 분석', '실전 모의고사', '1:1 첨삭 지도'],
    curriculum: [
      {
        week: '1-4주차',
        title: '문학 기초 완성',
        contents: ['현대시 감상법과 핵심 개념', '고전시가 독해 전략', '현대소설 서사 구조 분석', '고전소설 배경지식 정리']
      },
      {
        week: '5-8주차',
        title: '독서 영역 심화',
        contents: ['인문·예술 지문 독해법', '사회·문화 지문 분석', '과학·기술 지문 접근법', '융합 지문 실전 연습']
      },
      {
        week: '9-12주차',
        title: '언어와 매체',
        contents: ['음운·형태론 핵심 정리', '통사론·의미론 완성', '매체 언어의 특성', '실전 문제 적용']
      },
      {
        week: '13-16주차',
        title: '실전 모의고사',
        contents: ['EBS 연계 분석', '시간 관리 전략', '고난도 문항 공략', '최종 마무리 점검']
      }
    ],
    benefits: ['매주 실전 모의고사 실시', '개인별 취약점 분석 리포트', '24시간 질문 답변 시스템', '수능 직전 파이널 특강 무료']
  },
  {
    id: 2,
    name: '학교별 내신반 편성',
    level: '고1-고2',
    description: '내신 1등급을 위한 심화 학습',
    fullDescription: '각 학교별 교과서와 시험 출제 경향을 완벽 분석하여 내신 1등급을 목표로 합니다. 학교별 맞춤 자료와 서술형 집중 훈련으로 실질적인 성적 향상을 이끌어냅니다.',
    schedule: '학교별 요일 시간 학원 문의',
    capacity: '20명',
    duration: '학기별 운영',
    instructor: '정기훈 선생님',
    features: ['교과서 완벽 분석', '학교별 맞춤 지도', '서술형 집중 훈련'],
    curriculum: [
      {
        week: '1-3주차',
        title: '교과서 핵심 정리',
        contents: ['단원별 핵심 개념 정리', '교과서 수록 작품 심층 분석', '학습 활동 완벽 대비']
      },
      {
        week: '4-6주차',
        title: '기출 문제 분석',
        contents: ['학교별 기출 패턴 분석', '출제 예상 문제 풀이', '오답 노트 작성법']
      },
      {
        week: '7-9주차',
        title: '서술형 집중 훈련',
        contents: ['서술형 답안 작성법', '채점 기준 분석', '실전 서술형 연습']
      },
      {
        week: '시험 직전',
        title: '파이널 정리',
        contents: ['핵심 내용 총정리', '예상 문제 풀이', '최종 점검 및 질의응답']
      }
    ],
    benefits: ['학교별 맞춤 자료 제공', '서술형 무제한 첨삭', '시험 직전 특별 보충', '성적 향상 보장제']
  },
  {
    id: 3,
    name: '중등 국어 기본반',
    level: '중1-중3',
    description: '국어 실력의 탄탄한 기초 다지기',
    fullDescription: '중학교 국어의 기초를 탄탄하게 다지는 과정입니다. 독해력, 어휘력, 문법 실력을 균형 있게 향상시켜 고등 국어의 기반을 마련합니다.',
    schedule: '월/수/금 17:00-19:00',
    capacity: '15명',
    duration: '3개월 과정',
    instructor: '이독해 선생님',
    features: ['독해력 향상', '어휘력 강화', '문법 기초 완성'],
    curriculum: [
      {
        week: '1-4주차',
        title: '독해력 기초',
        contents: ['글의 구조 파악하기', '중심 내용 찾기', '추론적 읽기 연습', '비판적 읽기 입문']
      },
      {
        week: '5-8주차',
        title: '어휘력 확장',
        contents: ['필수 어휘 500선', '한자어 기초', '관용 표현 익히기', '맥락 속 어휘 학습']
      },
      {
        week: '9-12주차',
        title: '문법 기초 완성',
        contents: ['품사의 이해', '문장 성분 분석', '올바른 문장 쓰기', '맞춤법과 띄어쓰기']
      }
    ],
    benefits: ['매일 어휘 테스트', '독서 지도 병행', '글쓰기 기초 훈련', '학부모 상담 월 1회']
  },
  {
    id: 4,
    name: '논술 특강반',
    level: '고2-고3',
    description: '대입 논술 완벽 대비',
    fullDescription: '주요 대학 논술 전형을 완벽 대비하는 특강반입니다. 대학별 출제 경향 분석과 실전 첨삭을 통해 논술 실력을 극대화합니다.',
    schedule: '토 14:00-18:00',
    capacity: '8명',
    duration: '4개월 과정',
    instructor: '최논술 선생님',
    features: ['대학별 논술 분석', '실전 첨삭', '개별 맞춤 지도'],
    curriculum: [
      {
        week: '1-4주차',
        title: '논술 기초 다지기',
        contents: ['논술의 기본 구조', '논증적 글쓰기', '제시문 분석법', '개요 작성 훈련']
      },
      {
        week: '5-8주차',
        title: '대학별 유형 분석',
        contents: ['인문계열 논술 특징', '사회계열 논술 특징', '통합교과형 논술', '대학별 기출 분석']
      },
      {
        week: '9-12주차',
        title: '실전 논술 훈련',
        contents: ['시간 내 글쓰기 연습', '실전 모의 논술', '개별 첨삭 및 피드백', '약점 보완 훈련']
      },
      {
        week: '13-16주차',
        title: '파이널 완성',
        contents: ['대학별 최종 점검', '예상 주제 분석', '실전 감각 극대화', '최종 모의 논술']
      }
    ],
    benefits: ['무제한 첨삭 서비스', '대학별 맞춤 자료', '1:1 개별 상담', '합격생 멘토링']
  },
  {
    id: 5,
    name: '약술형 소논술반',
    level: '고3',
    description: '약술형·소논술 서술 능력 완성',
    fullDescription: '대입에서 비중이 높아지는 약술형·소논술 문항을 집중 대비하는 반입니다. 논리적 사고력과 서술 표현력을 체계적으로 훈련하여 서술형 문항에서 감점 없는 완벽한 답안 작성 능력을 길러줍니다.',
    schedule: '학원 문의',
    capacity: '15명',
    duration: '3개월 과정',
    instructor: '정기훈 원장',
    features: ['약술형 답안 작성법', '소논술 첨삭 지도', '학교별 기출 분석'],
    curriculum: [
      {
        week: '1-3주차',
        title: '서술형 기초 훈련',
        contents: ['논리적 문장 구성법', '핵심 논지 파악 훈련', '조건 충족형 답안 작성법']
      },
      {
        week: '4-6주차',
        title: '약술형 실전 연습',
        contents: ['약술형 유형별 접근법', '제한 글자 수 내 핵심 서술', '채점 기준 분석 및 적용']
      },
      {
        week: '7-9주차',
        title: '소논술 심화 훈련',
        contents: ['제시문 분석과 논점 도출', '근거 제시와 논증 구조화', '소논술 실전 작성 및 첨삭']
      },
      {
        week: '10-12주차',
        title: '실전 마무리',
        contents: ['학교별 기출 약술형 풀이', '실전 모의 서술형 시험', '개별 피드백 및 최종 점검']
      }
    ],
    benefits: ['무제한 첨삭 서비스', '학교별 맞춤 기출 자료', '소수 정예 개별 지도', '서술형 답안 작성 노하우 제공']
  }
];